export const getEmbedDomain = () => {
    const hostname = window.location.hostname || "localhost";
    return hostname;
  };